import { apiBaseUrls, cacheService, EnvType, Hubs } from "./services";
import { HttpTransportType, HubConnection, HubConnectionBuilder, HubConnectionState } from "@microsoft/signalr";

export enum EventNotifierOperation {
  Create = "Create",
  Update = "Update",
  Delete = "Delete",
}

export default class SignalRNotifier {
  readonly servicePort = 5000;
  connection: HubConnection | null;
  endpoint: string;
  hub: string;

  constructor(envType: EnvType, hub: Hubs) {
    this.endpoint =
      apiBaseUrls[envType] + (envType === "local" ? this.servicePort.toString() + "/" : "") + "websocket/hubs/" + hub;
    this.hub = hub;
    this.connection = null;
  }

  async Connect(): Promise<boolean> {
    this.connection = new HubConnectionBuilder()
      .withUrl(this.endpoint, {
        accessTokenFactory: () => cacheService.GetAuthKey()!,
        skipNegotiation: true,
        transport: HttpTransportType.WebSockets,
      })
      .withAutomaticReconnect()
      .build();

    await this.connection
      ?.start()
      .then(() => {
        console.info("[Notifier] Hub " + this.hub + " connected successfully");
      })
      .catch((e) => {
        console.error("[Notifier] Hub " + this.hub + " connection failed: ", e);
      });

    console.info("[Notifier] Hub " + this.hub + " state is " + this.connection.state);
    return this.connection.state === HubConnectionState.Connected;
  }

  async Disconnect(): Promise<boolean> {
    if (this.connection === null) {
      console.warn("[Notifier] Disconnect Hub " + this.hub + " not possible for null connection");
      return false;
    }

    this.connection
      ?.stop()
      .catch(function (err) {
        console.warn(
          "[Notifier] " +
            this.hub +
            " servers appears to be offline, please use F5 or Ctrl+R to update the displayed content."
        );
        return false;
      })
      .then(function () {
        console.info("[Notifier] Hub " + (this ? this.hub : "") + " disconnected");
        //this.connection = null;
        return true;
      });

    return true;
  }
}
